import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken
} from 'keycloak-angular';
import {environment} from '../environments/environment';


const urlPattern = /^https:\/\/echo\.free\.beeceptor\.com(?:\/[^\\?]*)?(?:\\?.*)?$/;
const ngRokPattern = /^https:\/\/[\w-]+\.ngrok\.app(?:\/[^\\?]*)?(?:\\?.*)?$/;
const cfWorkerPattern = /^https:\/\/[\w-]+(?:\.[\w-]+)*\.workers\.dev(?:\/[^\\?]*)?(?:\\?.*)?$/;
// eslint-disable-next-line no-useless-escape
const trackstreamPattern = /^https:\/\/[^\/]+\.((staging\.)?api\.trackstream\.app)\/.*$/;


const echoCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern,
  bearerPrefix: 'Bearer'
});

const ngRokCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: ngRokPattern,
  bearerPrefix: 'Bearer'
});

const cfWorkerCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: cfWorkerPattern,
  bearerPrefix: 'Bearer'
});

const trackstreamCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: trackstreamPattern,
  bearerPrefix: 'Bearer'
});


export const provideKeycloakAngular = () => {
  return provideKeycloak({
    config: {
      realm: 'track-stream',
      url: 'https://keycloak.trackstream.app/',
      clientId: 'tracker-stream-frontend'
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: environment.tokenTimeoutDuration
      })
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [ echoCondition, ngRokCondition, cfWorkerCondition, trackstreamCondition ],
      }
    ]
  });
};
